import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTraining = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "school-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc5 {\n        fill: #0573A9;\n      }\n    " }) }), /* @__PURE__ */ _jsx("path", {
		className: "secc5",
		d: "M13.9502,4.40009c0-.19629-.10449-.37793-.27441-.47607L7.27539.22382c-.16895-.09717-.37549-.09814-.54492-.00342L.33057,3.8205c-.17139.09619-.27832.27686-.28027.47314-.00244.19629.1001.37891.26904.47949l2.03076,1.20575v3.5213c0,.19922.10742.38281.28076.47949l4.1001,2.2998c.0835.04688.17627.07031.26904.07031s.18555-.02344.26904-.07031l4.1001-2.2998c.17285-.09668.28027-.28027.28027-.47949v-3.4527l1.10059-.63617v3.98828c0,.30371.24609.5498.5498.5498s.5498-.24609.5498-.5498v-4.69751c.06018-.08936.10059-.19061.10059-.302ZM3.44971,9.17792v-2.5462l3.00049,1.78149v2.44733l-3.00049-1.68262ZM10.5498,9.17792l-3,1.68262v-2.4433l3-1.73413v2.49481ZM7.01855,7.4541c-.00653-.00024-.01196-.00372-.01855-.00372-.00439,0-.00806.00238-.01245.0025L1.69922,4.31268,6.99609,1.33319l5.30566,3.06689-5.2832,3.05402Z"
	})]
});
export default SvgTraining;
